import axios from 'axios';

export const attachmentService = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/attachments/upload', formData, {
      auth: true,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  delete: (key) =>
    axios.delete(`/attachments/${encodeURIComponent(key)}`, { auth: true }),
};
